import { cva as e } from "class-variance-authority";
// src/design/badge/style.ts
var t = e("inline-flex items-center font-medium whitespace-nowrap transition-colors rounded-md", {
	variants: {
		size: {
			xs: "text-2xs leading-[110%] px-1 py-0.5 gap-0.5",
			sm: "text-xs leading-[120%] px-1 py-0.5 gap-1",
			md: "text-label leading-[130%] px-1.5 py-1 gap-1",
			lg: "text-sm leading-[150%] px-2.5 py-1 gap-1.5"
		},
		variant: {
			"fill-primary": "bg-primary text-primary-foreground border-0",
			"fill-default": "bg-neutral-solid text-neutral-solid-foreground border-0",
			"fill-success": "bg-success text-success-foreground border-0",
			"fill-danger": "bg-destructive text-destructive-foreground border-0",
			"fill-warning": "bg-warning text-warning-foreground border-0",
			"fill-info": "bg-info text-info-foreground border-0",
			"fill-discovery": "bg-discovery text-discovery-foreground border-0",
			"compact-primary": "rounded-sm text-xs px-1 py-0 leading-0 h-4 bg-primary text-primary-foreground border-0",
			"compact-default": "rounded-sm text-xs px-1 py-0 leading-0 h-4 bg-neutral-solid text-neutral-solid-foreground border-0",
			"compact-success": "rounded-sm text-xs px-1 py-0 leading-0 h-4 bg-success text-success-foreground border-0",
			"compact-danger": "rounded-sm text-xs px-1 py-0 leading-0 h-4 bg-destructive text-destructive-foreground border-0",
			"compact-warning": "rounded-sm text-xs px-1 py-0 leading-0 h-4 bg-warning text-warning-foreground border-0",
			"compact-info": "rounded-sm text-xs px-1 py-0 leading-0 h-4 bg-info text-info-foreground border-0",
			"compact-discovery": "rounded-sm text-xs px-1 py-0 leading-0 h-4 bg-discovery text-discovery-foreground border-0",
			"soft-primary": "bg-secondary text-primary border-0",
			"soft-default": "bg-muted text-foreground border-0",
			"soft-success": "bg-success/10 text-success-text border-0",
			"soft-danger": "bg-destructive/10 text-destructive border-0",
			"soft-warning": "bg-warning/10 text-warning-text border-0",
			"soft-info": "bg-info/10 text-info-text border-0",
			"soft-discovery": "bg-discovery/10 text-discovery-text border-0",
			"outline-primary": "bg-muted text-primary border border-primary",
			"outline-default": "bg-muted text-foreground border border-neutral-solid",
			"outline-success": "bg-muted text-success-text border border-success",
			"outline-danger": "bg-muted text-destructive border border-destructive",
			"outline-warning": "bg-muted text-warning-text border border-warning",
			"outline-info": "bg-muted text-info-text border border-info",
			"outline-discovery": "bg-muted text-discovery-text border border-discovery"
		}
	},
	defaultVariants: {
		variant: "soft-default",
		size: "sm"
	}
}), n = e("inline-block rounded-full", {
	variants: {
		variant: {
			"fill-primary": "bg-primary",
			"fill-default": "bg-neutral-solid",
			"fill-success": "bg-success",
			"fill-danger": "bg-destructive",
			"fill-warning": "bg-warning",
			"fill-info": "bg-info",
			"fill-discovery": "bg-discovery",
			"compact-primary": "bg-primary",
			"compact-default": "bg-neutral-solid",
			"compact-success": "bg-success",
			"compact-danger": "bg-destructive",
			"compact-warning": "bg-warning",
			"compact-info": "bg-info",
			"compact-discovery": "bg-discovery",
			"soft-primary": "bg-primary",
			"soft-default": "bg-neutral-solid",
			"soft-success": "bg-success",
			"soft-danger": "bg-destructive",
			"soft-warning": "bg-warning",
			"soft-info": "bg-info",
			"soft-discovery": "bg-discovery",
			"outline-primary": "bg-primary",
			"outline-default": "bg-neutral-solid",
			"outline-success": "bg-success",
			"outline-danger": "bg-destructive",
			"outline-warning": "bg-warning",
			"outline-info": "bg-info",
			"outline-discovery": "bg-discovery"
		},
		size: {
			xs: "w-1 h-1",
			sm: "w-1.5 h-1.5",
			md: "w-2 h-2",
			lg: "w-2.5 h-2.5"
		}
	},
	defaultVariants: {
		variant: "soft-default",
		size: "sm"
	}
}), r = e("shrink-0", {
	variants: {
		size: {
			xs: "w-3 h-3",
			sm: "w-3 h-3",
			md: "w-4 h-4",
			lg: "w-4 h-4"
		},
		position: {
			left: "",
			right: ""
		}
	},
	defaultVariants: {
		size: "sm",
		position: "left"
	}
}), i = e("ml-1 -mr-1 shrink-0 rounded-sm opacity-70 hover:opacity-100 cursor-pointer transition-opacity", {
	variants: { size: {
		xs: "p-0",
		sm: "p-0.5",
		md: "p-0.5",
		lg: "p-1"
	} },
	defaultVariants: { size: "sm" }
}), a = (e) => `inline-flex flex-wrap items-center ${{
	sm: "gap-1",
	md: "gap-2",
	lg: "gap-3"
}[e]}`;
function o() {
	return {
		root: (e) => t({
			variant: e?.variant,
			size: e?.size
		}),
		dot: (e) => n({
			variant: e?.variant,
			size: e?.size
		}),
		icon: (e) => r({
			size: e?.size,
			position: e?.position
		}),
		removeButton: (e) => i({ size: e?.size }),
		group: (e = "md") => a(e)
	};
}
export { o as default, o as getStyles };

//# sourceMappingURL=style.js.map